import axios from "axios";

export const fastapiVmInstance = axios.create({
	baseURL: process.env.REACT_APP_FAST_APP_API_URL,
});

fastapiVmInstance.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("user_token"); // or from context/state
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

// Response middleware
fastapiVmInstance.interceptors.response.use(
	(response) => {
		console.log("✅ Response:", response.status, response.config.url);
		return response;
	},
	(error) => {
		if (error.response?.status === 401) {
			console.warn("🔒 Unauthorized! Redirecting to login...");
			localStorage.removeItem("token");
			//   window.location.href = "/login";
			window.location.reload(true);
		}
		return Promise.reject(error);
	}
);
